import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    imports: [FaIconComponent]
})
export class AccordionComponent implements OnInit {
    faChevronDown = faChevronDown;
    faChevronUp = faChevronUp;
    accordionOpen: boolean = false;
    @Input() title: string = '';
    @Input() content: string = '';
    @Input() white: boolean = false;
    @Input() open: boolean = false;

    safeHtml!: SafeHtml;

    constructor(private domSanitizer: DomSanitizer) {
    }

    ngOnInit(): void {
        if (this.open) this.accordionOpen = true;

        this.safeHtml = this.domSanitizer.bypassSecurityTrustHtml(this.content);
    }

    onToggleView(): void {
        this.accordionOpen = !this.accordionOpen;
    }
}
